import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";

/**
 * Params of the link that opened the form. The live URL wins when it is a
 * form entry URL, because App copies it into sessionStorage only after child
 * effects have run, so storage can still hold a previous link's params. Other
 * pages (like results) carry their own params and fall back to storage.
 */
export function getStoredSearchParams(): URLSearchParams {
  try {
    const live = new URLSearchParams(window.location.search);
    if (live.has("parentLocation")) return live;
    return new URLSearchParams(sessionStorage.getItem("searchParams") || "");
  } catch {
    return new URLSearchParams();
  }
}

/**
 * Phone number the assessment link was texted to, in E.164 form. Only links
 * sent by SMS carry the `sms` parameter, so assisted and emailed links return
 * undefined.
 */
export function getPrefillPhone(): string | undefined {
  const raw = getStoredSearchParams().get("sms");
  if (!raw) return undefined;
  const cleaned = raw.replace(/[^\d+]/g, "");
  if (!cleaned) return undefined;
  const parsed = parsePhoneNumber(cleaned, "US");
  return parsed && isValidPhoneNumber(parsed.number) ? parsed.number : undefined;
}

export function getPracticeName(): string | undefined {
  const name = getStoredSearchParams().get("practiceName")?.trim();
  return name || undefined;
}

export function getFormId(): string | undefined {
  const params = getStoredSearchParams();
  return params.get("formId") || params.get("id") || undefined;
}

export function getParentOrigin(): string | undefined {
  const parentLocation = getStoredSearchParams().get("parentLocation");
  if (!parentLocation) return undefined;
  try {
    return new URL(parentLocation).origin;
  } catch {
    return undefined;
  }
}
